import React, { useEffect, useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { Api_Url } from "../../../config/config";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { AuthContext } from "../../../Context/AuthContext";
import { Applogo } from "../../../Routes/ImagePath";
// import toast from 'react-hot-toast';

import { ErrorToast, SuccessToast } from "../../ToastComponent";

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Please enter a valid email address")
    .required("Email is required"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .max(20, "Password must be at most 20 characters")
    .required("Password is required"),
});

const Login = () => {
  const { login } = useContext(AuthContext);
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${Api_Url}api/Account/authenticate`,
        data
      );

      // console.log("loginData",response.data.data?.isVerified);
      login(response.data.data);
      console.log("user", response.data);
      if (response.data.succeeded) {
        navigate("/roles");
        SuccessToast("Login Successfully");
      }
    } catch (error) {
      ErrorToast("Credential is Wrong!! Try again");
      console.error(error);
    } finally {
      setLoading(false); // Stop loader
    }
  };

  useEffect(() => {
    const userData = JSON.parse(sessionStorage.getItem("user"));
    console.log(userData);
    if (userData) {
      navigate("/roles");
    } else {
      navigate("/login");
    }
  }, []);

  return (
    <div>
      <div className="account-page">
        <div className="main-wrapper">
          <div className="account-content">
            <div className="container">
              <div className="account-logo">
                <Link to="/admin-dashboard">
                  <img
                    src={Applogo}
                    alt="Roha housing"
                    style={{ height: "10vh", width: "25vw" }}
                  />
                </Link>
              </div>
              <div className="account-box">
                <div className="account-wrapper">
                  <h3 className="account-title">Login</h3>
                  <p className="account-subtitle">Access to our dashboard</p>

                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="input-block mb-4">
                      <label className="col-form-label">Email Address</label>
                      <input
                        className={`form-control ${
                          errors.email ? "is-invalid" : ""
                        }`}
                        type="text"
                        {...register("email")}
                      />
                      <span className="text-danger">
                        {errors.email?.message}
                      </span>
                    </div>
                    <div className="input-block mb-4">
                      <div className="row">
                        <div className="col">
                          <label className="col-form-label">Password</label>
                        </div>
                        <div className="col-auto">
                          <Link className="text-muted" to="/forgot-password">
                            Forgot password?
                          </Link>
                        </div>
                      </div>
                      <div style={{ position: "relative" }}>
                        <input
                          className={`form-control ${
                            errors.password ? "is-invalid" : ""
                          }`}
                          type="password"
                          {...register("password")}
                        />
                        <span className="text-danger">
                          {errors.password?.message}
                        </span>
                      </div>
                    </div>
                    <div className="input-block text-center">
                      <button
                        className="btn btn-primary account-btn"
                        type="submit"
                        disabled={loading}
                      >
                        Login
                      </button>
                    </div>
                  </form>
                  {loading && (
                    <div className="text-center mt-3">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  )}
                  <div className="account-footer">
                    <p>
                      <Link to="/loginwithmobile">Login with Mobile</Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
